export default {
      id: "icon-linkedin-usage",
      viewBox: "0 0 68 67",
      url: "../icon/" + "icons.svg#icon-linkedin-usage",
      toString: function () {
        return this.url;
      }
    }